export default __webpack_public_path__ + "static/media/evo_bg.fc5ff632.png";